import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
  PLAN_CREATED,
  PLAN_DELETED,
  PLAN_UPDATED,
  useEventsSubscriber,
  usePlansService
} from 'nekst-api';
import { Dropdown, Option } from 'ui-builder';

export interface ChoosePlanDropdownProps {
  value?: number;
}

export default function ChoosePlanDropdown(props: ChoosePlanDropdownProps) {
  const [loaded, setLoaded] = useState<boolean>(false);

  const navigate = useNavigate();

  const plansService = usePlansService();

  const [plansOptions, setPlansOptions] = useState<Option[]>([]);

  const loadPlans = async (): Promise<void> => {
    const plans = await plansService.getAllTeamPlans();

    const options = plans.map(
      (plan) => {
        return {
          value: plan.id,
          label: plan.name,
        };
      },
    );

    setPlansOptions(options);
    setLoaded(true);
  };

  useEventsSubscriber(
    'ChoosePlanDropdown',
    {
      [PLAN_UPDATED]: loadPlans,
      [PLAN_CREATED]: loadPlans,
      [PLAN_DELETED]: loadPlans,
    },
    [],
    loadPlans,
  );

  if (loaded) {
    return (
      <Dropdown
        options={plansOptions}
        source="dropdown"
        placeholder="Choose plan"
        label="Select an existing plan"
        value={props.value || null}
        onChangeCallback={(v) => {
          if (v.dropdown) {
            navigate(`/plans/${v.dropdown}`);
          } else {
            navigate('/plans');
          }
        }}
      />
    );
  } else {
    return (<div>Loading...</div>);
  }
}
